<img [src]="path" alt="">